import { useRef, useState } from 'react';
import css from './button.module.scss';
import { IWorkshopTemplateData } from '../../../../../../entities/template/types';
import { MainButton } from '../../../../../../components/ui/main-button/main-button';

interface IAddTagButtonProps {
	onChange: () => void,
}

export const AddCategoryButton = (props: IAddTagButtonProps) => {
	const { onChange } = props;

	const [isDropdownOpen, setDropdownOpen] = useState(false);
	const buttonRef = useRef<HTMLButtonElement>(null);

	const handleButtonClick = () => {
		setDropdownOpen(!isDropdownOpen);
	};

	return (
		<div
			className={css.addTagContainer}
			style={{ position: 'relative' }}
			onClick={onChange}
		>
			<MainButton
				ref={buttonRef}
				onClick={handleButtonClick}
				btnStyle="light"
				type="button"
			>
				Добавить категорию
			</MainButton>
		</div>
	);
};
